import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip, styled } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../../../context/LanguageContext';
import { useAuth } from '../../../../context/AuthProvider';
import { useLayoutPreferences } from '../../../../context/LayoutPreferencesContext';

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    padding: '10px 20px',
    minWidth: 180,
    fontSize: '14px',
    '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.08),
    },
}));

const SettingsMenu = () => {
    const { t } = useLanguage();
    const { logout } = useAuth();
    const navigate = useNavigate();
    const theme = useTheme();
    const { topbarTheme } = useLayoutPreferences();
    const iconColor = topbarTheme === 'dark' ? theme.palette.grey[400] : theme.palette.text.primary;
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleProfile = () => {
        handleClose();
        navigate('/profile');
    };

    const handleSettings = () => {
        handleClose();
        navigate('/settings');
    };

    const handleHelp = () => {
        handleClose();
        window.open('https://support.be-one.fr', '_blank');
    };

    const handleLogout = () => {
        handleClose();
        logout();
    };

    return (
        <>
            <Tooltip title={t('common.settings') || 'Paramètres'}>
                <IconButton 
                    onClick={handleClick}
                    sx={{ 
                        color: iconColor,
                        '&:hover': {
                            backgroundColor: alpha(theme.palette.text.primary, 0.1)
                        }
                    }}
                >
                    <i className="bx bx-cog" style={{ fontSize: 22 }} />
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                PaperProps={{
                    elevation: 3,
                    sx: {
                        mt: 1.5,
                        minWidth: 180,
                        borderRadius: 2,
                        '& .MuiList-root': {
                            padding: '8px 0',
                        },
                    },
                }}
            >
                <StyledMenuItem onClick={handleProfile}>
                    <ListItemIcon>
                        <i className="bx bx-user" style={{ fontSize: 20, color: theme.palette.text.primary }} />
                    </ListItemIcon>
                    <ListItemText>{t('header.profile')}</ListItemText>
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSettings}>
                    <ListItemIcon>
                        <i className="bx bx-cog" style={{ fontSize: 20, color: theme.palette.text.primary }} />
                    </ListItemIcon>
                    <ListItemText>{t('common.settings')}</ListItemText>
                </StyledMenuItem>
                <StyledMenuItem onClick={handleHelp}>
                    <ListItemIcon>
                        <i className="bx bx-help-circle" style={{ fontSize: 20, color: theme.palette.text.primary }} />
                    </ListItemIcon>
                    <ListItemText>{t('header.help')}</ListItemText>
                </StyledMenuItem>
                <StyledMenuItem onClick={handleLogout}>
                    <ListItemIcon>
                        <i className="bx bx-log-out" style={{ fontSize: 20, color: theme.palette.text.primary }} />
                    </ListItemIcon>
                    <ListItemText>{t('common.logout')}</ListItemText>
                </StyledMenuItem>
            </Menu>
        </>
    );
};

export default SettingsMenu;
